import { useRef } from "react";
import { formatDate } from "../Functions/formatDate";
import InstalledSitesPopup from "../Popups/InstalledSitesPopup";
import { PaymentTable } from "../Devadmin/DevadminPayments";


const UserSubscriptionDetails = ({ selectedSubscription, onBack }) => {
  const installRef = useRef(null);
  
  if (!selectedSubscription) return null;

  // Sort payments by date (newest first)
  const sortedPayments = [...(selectedSubscription.payments || [])].sort(
    (a, b) => new Date(b.created) - new Date(a.created)
  );
  selectedSubscription.payments = sortedPayments;

  // Format price with 2 decimal places
  const formatPrice = (amount) => {
    return `$${amount?.toFixed(2) || "0.00"}`;
  };
  
  const handleOpenPopup = () => {
    const widgetId = selectedSubscription.widgetType._id;
    const sites = selectedSubscription.sites;

    if (installRef.current) {
      installRef.current.openPopup(widgetId, sites, false);
    }
  };

  return (
    <div className="mjwi-subscription-details-container">
      <button className="mjwi-back-button" onClick={onBack}>
        ← Back to List
      </button>

      <div className="mjwi-details-sections">
        {/* Subscription Information Section */}
        <section className="mjwi-details-section">
          <h2 className="mjwi-section-title">Subscription Details</h2>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Status:</span>
            <span className="mjwi-detail-value">
              {selectedSubscription.subStatus}
            </span>
          </div>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Monthly Total:</span>
            <span className="mjwi-detail-value">
              {formatPrice(selectedSubscription.widgetType?.price)}/month
            </span>
          </div>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Yearly Total:</span>
            <span className="mjwi-detail-value">
              {formatPrice(selectedSubscription.widgetType?.price * 12)}/year
            </span>
          </div>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Created Date:</span>
            <span className="mjwi-detail-value">
              {selectedSubscription.payments?.[0]?.created
                ? formatDate(selectedSubscription.payments[0].created)
                : "N/A"}
            </span>
          </div>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Renewal Date:</span>
            <span className="mjwi-detail-value">
              {selectedSubscription.expires
                ? formatDate(selectedSubscription.expires)
                : "N/A"}
            </span>
          </div>
        </section>

        {/* Product and Customer Information Section */}
        <section className="mjwi-details-section">
          <h2 className="mjwi-section-title">Product Details</h2>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Product Name:</span>
            <span className="mjwi-detail-value">
              {selectedSubscription.title || "N/A"}
            </span>
          </div>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Type:</span>
            <span className="mjwi-detail-value">
              {selectedSubscription.widgetType?.name || "N/A"}
            </span>
          </div>
          <div onClick={handleOpenPopup} className="mjwi-detail-item">
            <span className="mjwi-detail-label">Installations:</span>
            <span className="mjwi-detail-value">
              {selectedSubscription.sites?.length + " " || 0 + " "}
              <i className="fa-solid fa-globe"></i>
            </span>
          </div>

          <h2 className="mjwi-section-title">Customer Details</h2>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Name:</span>
            <span className="mjwi-detail-value">
              {selectedSubscription.userId?.displayName || selectedSubscription?.widgetId?.userId?.displayName || "N/A"}
            </span>
          </div>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Email:</span>
            <span className="mjwi-detail-value">
              {selectedSubscription.userId?.email || selectedSubscription?.widgetId?.userId?.email || "N/A"}
            </span>
          </div>
        </section>

        {/* Payment Information Section */}
        <section className="mjwi-details-section span-2">
          <h2 className="mjwi-section-title">Payment Details</h2>
          <h4
            style={{ color: "#7d7777", fontSize: "16px" }}
            className="mjwi-subsection-lable"
          >
            Upcoming Payment
          </h4>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Amount:</span>
            <span className="mjwi-detail-value">
              {formatPrice(selectedSubscription.widgetType?.price)}/month
            </span>
          </div>
          <div className="mjwi-detail-item">
            <span className="mjwi-detail-label">Due Date:</span>
            <span className="mjwi-detail-value">
              {selectedSubscription.expires
                ? formatDate(selectedSubscription.expires)
                : "N/A"}
            </span>
          </div>

          <div  style={{ height: "fit-content"}}>
            <h3
              style={{ color: "#7d7777", fontSize: "16px" }}
              className="mjwi-subsection-label"
            >
              Payment History
            </h3>
          </div>
          <div className="mjwi-table mjwi-subscription-page">
              <PaymentTable
              payments={selectedSubscription?.payments || []}
              styleSubscription={"fit-content"}
            />
            </div>
        </section>
        <InstalledSitesPopup ref={installRef} />
      </div>
    </div>
  );
};

export default UserSubscriptionDetails;